import { observable, computed, action } from "mobx";
import {PATH_MENU_LEFT_PROFILO} from '../config/portale-config'

const menuItemsLM = [
  {
    exact: false,
    label: "Dati Generali",
    path: "/adempimento/datigenerali",
    subItems: [
        {
            label: "Chiave Adempimentooo",
            path: "/adempimento/datigenerali/chiaveAdempimento",
            exact: false             
        },
        {
          label: "Dati Titolo",
          path: "/adempimento/datigenerali/datiTitolo",
          exact: false
      }
    ]
}
]

class LeftMenuStore {

  constructor(root) {
    this.service = root.service
  }


  @observable menuItems = []
  @observable label = ""
  @observable fetched = false

  @action
  fetchLeftMenu() {

    if (!this.fetched)   
      this.service.doAjax('GET', PATH_MENU_LEFT_PROFILO).then(response => {
        if (response.success) {         
          this.menuItems = response.result.items;         
          this.label = response.result.sectionTitle.label          
         
        }
        this.fetched = true
        
      })
  }
}

export default LeftMenuStore;